export function formatByteSize(byteSize: number): string {
  if (!Number.isFinite(byteSize) || byteSize <= 0) return "0 B";

  const units = ["B", "KB", "MB", "GB"];
  let size = byteSize;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  const decimals = unitIndex === 0 ? 0 : 1;
  return `${size.toFixed(decimals).replace(/\.0$/, "")} ${units[unitIndex]}`;
}

export function participantDisplayName(participant: {
  name: string;
  email: string;
}): string {
  return participant.name || participant.email.split("@")[0];
}
